import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ListChecks } from "lucide-react";
import {
  BooleanInput,
  Create,
  NumberInput,
  SimpleForm,
  TextInput,
} from "../common";

export const LeaveTypeCreate = () => (
  <Create title="Create Leave Type">
    <SimpleForm className="max-w-3xl mx-auto space-y-6">
      <Card className="w-full shadow-sm">
        <CardHeader className="pb-3 border-b bg-muted/50">
          <div className="flex items-center gap-2">
            <ListChecks className="w-5 h-5 text-muted-foreground" />
            <CardTitle className="text-lg font-semibold tracking-tight">Add Leave Type</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <TextInput source="name" label="Leave Type Name" />
            <TextInput source="code" label="Code" />
            <NumberInput source="days_per_year" defaultValue={0} label="Days Per Year" />
          </div>
          <div className="flex gap-6 mt-4">
            <BooleanInput source="paid" defaultValue label="Paid Leave" />
            <BooleanInput source="carry_forward" label="Carry Forward" />
          </div>
        </CardContent>
      </Card>
    </SimpleForm>
  </Create>
);
